// Point-to-ask's rules (E09-S3-T6), shared by the session client, which drives the host's point mode,
// and the composer's crosshair control, which offers it. Pure: nothing here touches the bridge.
import { REF_ID_RE } from "@waypoint/contracts";
/** Point mode ends by itself after this long with no click. */
export const POINT_TIMEOUT_MS = 20_000;
/** Point mode off, with nothing to report: a view's starting point. */
export const POINT_OFF = Object.freeze({ on: false, last: null });
/**
 * Can this view point? Only when it declared pointing, a source is sending frames, perception is not
 * paused — neither in the session nor by this view, whose own pause takes effect before the server
 * hears of it — and the session reads at tier 1 or above. Offering the control otherwise would
 * promise something the view cannot do. Tier 0 reads no field (every atlas field's minTier is at
 * least 1), so every point there would end in "nothing approved" (lead decision, T4b, 20 Oct 2026).
 */
export function canPoint(s) {
    const seeing = s.session.state?.seeing;
    return (s.view.capabilities.pointing &&
        !s.view.pauseAsked &&
        seeing !== undefined &&
        seeing.sourceId !== null &&
        !seeing.paused &&
        seeing.tier >= 1);
}
/**
 * Is what the host reported an atlas field id? Perception reports a click on anything but a declared
 * field readable at the session's tier with no field id (E05-S6-T5); HostBridge's `pointed` types
 * the id as a string, so a shell passes that answer on as something no atlas field can be called —
 * null, empty, or not a field id at all (atlas field ids are reference ids, D-04). Each is the same
 * answer: nothing approved can be read there.
 */
export function isAtlasFieldId(fieldId) {
    return typeof fieldId === "string" && REF_ID_RE.test(fieldId);
}
//# sourceMappingURL=point.js.map